import {useState} from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import Home from './Component/Home';
import Installation from './Component/Ethereum/Installation';
import Success from './Component/Ethereum/Success';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Generator from './Component/Common/Generator';
import Index from './Component/Polygon/Index'
import BscIndex from './Component/Binance/Index';
import Installing from './Component/Polygon/Installing'
import Install from './Component/Binance/Install';

function App() {
  const [network,setNetwork] = useState('')
  const [confirm, setConfirm] = useState(true)
 
  


  const confirmbutton = (e) =>{
    setConfirm(e) 
    console.log(e)
  }
  const changenetwork = (e) => {
    setNetwork(e)
    console.log(e)
  }


  

  return (
    <>
      <BrowserRouter> 
      
        <Routes>
          <Route path="/" element={<Generator/>}/>
          <Route path="/createEthToken" element={<Home changenetwork={changenetwork} 
          network={network}
          confirm={confirm}
          confirmbutton={confirmbutton}/>} />
          <Route path="/installation"element={<Installation/>} />
          <Route path="/createPolyToken" element={<Index  confirm={confirm}
           confirmbutton={confirmbutton}  network={network}  changenetwork={changenetwork}  />}/>
          <Route path="/installing" element={<Installing/>}/>
          <Route path="/createbsctoken" element={<BscIndex    confirm={confirm}
           confirmbutton={confirmbutton}  network={network}  changenetwork={changenetwork}  />}/>
           <Route path="/install" element={<Install/>}/>
        </Routes>
        <ToastContainer />
      </BrowserRouter>
      
      </>
      
  );
}
export default App;